import axiosIns from '../../../xaxios';
import { obtenerUrl } from '../utils';

const create = async (datos) => {
  return await axiosIns.post(obtenerUrl('comprobantes-reversiones'), datos);
};

export default {
  create,
};
